// app/src/lib/scale/device.js — per-device identity.
//
// The app is single-device by design ("your phone, and that's it"): the owner's
// device is always the writer, so there is no primary/secondary coordination.
// This module just holds a stable per-device id, persisted in idbKv (separate
// store; survives sign-out + Dexie reset).

import * as kv from '../idbKv.js';

const DEVICE_KEY = 'kanjo.deviceId.v1';

let _id = null;

/** Stable random id for THIS browser/device. Generated once, persisted. */
export async function getDeviceId() {
  if (_id) return _id;
  let id = await kv.get(DEVICE_KEY);
  if (typeof id !== 'string' || !id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    await kv.set(DEVICE_KEY, id);
  }
  _id = id;
  return id;
}
